import { useCallback } from 'react';
import { LessonForm } from 'components/views/editor/models/LessonForm';
import { IGetLessonWithVersionsResponse } from 'api/models/response/IGetLessonWithVersionsResponse';

interface UseExportHandlersProps {
    lessonData: IGetLessonWithVersionsResponse | null;
    lessonFormData: LessonForm | null;
    editor: any;
    isLessonFormValid: (data: LessonForm) => boolean;
    isNodeEditorValid: (editor: any) => boolean;
    fetchTrainingWithProgress: (params: { lessonId: string }) => Promise<any>;
    fetchTrainingWithProgressPending: boolean;
}

const downloadFile = (content: string, fileName: string, contentType: string) => {
    const file = new Blob([content], { type: contentType });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(a.href);
};

export const useExportHandlers = ({
                                      lessonData,
                                      lessonFormData,
                                      editor,
                                      isLessonFormValid,
                                      isNodeEditorValid,
                                      fetchTrainingWithProgress,
                                      fetchTrainingWithProgressPending
                                  }: UseExportHandlersProps) => {

    const handleExportToVrClick = useCallback(async () => {
        if (!lessonData || fetchTrainingWithProgressPending) return;

        const response = await fetchTrainingWithProgress({
            lessonId: lessonData.lessonId
        });

        if (response?.success && response.data) {
            const fileName = `${lessonData.lessonName}.json`;
            const trainingForExportJson = JSON.stringify(response.data, null, 4);
            downloadFile(trainingForExportJson, fileName, 'application/json');
        }
    }, [lessonData, fetchTrainingWithProgress, fetchTrainingWithProgressPending]);

    const handleExportClick = useCallback(() => {
        if (!lessonData || !lessonFormData || !editor) return;
        if (!isLessonFormValid(lessonFormData) || !isNodeEditorValid(editor)) return;

        const fileName = `${lessonFormData.lessonVersionName}.txt`;
        const trainingForExportTxt = JSON.stringify(editor.toJSON(), null, 4);
        downloadFile(trainingForExportTxt, fileName, 'text/plain');
    }, [lessonData, lessonFormData, editor, isLessonFormValid, isNodeEditorValid]);

    return {
        handleExportClick,
        handleExportToVrClick
    };
};